import api from './index'

const orderService = {
    getOrders: async () => {
        try {
            const res = await api.get('/api/v1/user/orders')
            return { success: true, data: res.data.data }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to fetch orders'
            console.error('API call failed:', error)
            return { success: false, message: errorMessage, error }
        }
    },

    getOrder: async (orderId) => {
        try {
            const res = await api.get(`/api/v1/user/orders/${orderId}`)
            return { success: true, data: res.data.data }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to fetch order'
            console.error('API call failed:', error)
            return { success: false, message: errorMessage, error }
        }
    },

    createOrder: async (orderData) => {
        try {
            const res = await api.post('/api/v1/user/orders', orderData)
            return { success: true, data: res.data.data }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to create order'
            console.error('API call failed:', error)
            return { success: false, message: errorMessage, error }
        }
    },

    updateOrder: async (orderId, orderData) => {
        try {
            const res = await api.put(`/api/v1/user/orders/${orderId}`, orderData)
            return { success: true, data: res.data.data }
        } catch (error) {
            const errorMessage = error.response?.data?.message || `Failed to update order with ID ${orderId}:`
            console.error('API call failed:', error)
            return { success: false, message: errorMessage, error }
        }
    },

    deleteOrder: async (orderId) => {
        try {
            const res = await api.delete(`/api/v1/user/orders/${orderId}`)
            return { success: true, data: res.data }
        } catch (error) {
            console.error(`Failed to delete order with ID ${orderId}:`, error)
            return { success: false, message: `Failed to delete order with ID ${orderId}` }
        }
    },
}

export default orderService
